import { API_URL_WHALESHARK_REPORT } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteItem = (uuid: string) =>
  apiInstance({
    url: API_URL_WHALESHARK_REPORT + uuid,
    method: "delete",
  });

export default deleteItem;
